import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

window.addEventListener('load', () => {
  gsap.registerPlugin(ScrollTrigger);

  let ctx;
  let resizeTimeout;

  const initAboutUsAnimation = () => {
    if (ctx) ctx.revert();

    const wrapper = document.querySelector('.about-us__animations-wrapper');
    if (!wrapper) return;

    ctx = gsap.context(() => {
      if (window.innerWidth < 1024) return;

      const items = gsap.utils.toArray('.about-us__areas-item');
      if (!items.length) return;

      const spans = items.map((item) => item.querySelector('span'));
      const dash = document.querySelector('.about-us__dash-first');
      const teamImage = document.querySelector('.about-us__team-image');
      const body = document.querySelector('.about-us__body');

      gsap.set([teamImage, body], { opacity: 0 });
      if (dash) gsap.set(dash, { height: 191 });

      const tl = gsap.timeline({
        scrollTrigger: {
          trigger: wrapper,
          start: 'top 20%',
          end: '+=2500',
          scrub: true,
        },
      });

      tl.to(items, { color: 'transparent', duration: 0.08, ease: 'none' });

      tl.to(
        items,
        {
          width: '48px',
          height: '48px',
          borderRadius: '150px',
          padding: 0,
          duration: 0.8,
          ease: 'none',
          top: '100%',
          left: '50%',
          backgroundColor: 'transparent',
          boxShadow: '0 0 0 0 transparent',
          xPercent: -50,
        },
        0
      );

      gsap.set(spans, {
        width: '20px',
        height: '20px',
        left: '13',
        top: '50%',
        yPercent: -50,
      });

      tl.to(
        spans,
        {
          left: '0',
          width: '48px',
          height: '48px',
          duration: 0.8,
          ease: 'none',
        },
        0
      );

      tl.fromTo(
        teamImage,
        { opacity: 0, scale: 0 },
        { opacity: 1, scale: 1, duration: 1, ease: 'power1.out' },
        '+=0.1'
      );

      tl.fromTo(
        body,
        { opacity: 0, y: 50 },
        { opacity: 1, y: 0, duration: 1, ease: 'power2.out' },
        '+=0.1'
      );

      tl.to(
        teamImage,
        { opacity: 0, scale: 0, duration: 0.8, ease: 'power1.in' },
        '+=0.1'
      );

      tl.to(
        body.querySelectorAll('.about-us__body h3'),
        {
          color: 'transparent',
          yPercent: -50,
          maxHeight: '0',
          duration: 0.8,
          ease: 'power2.in',
        },
        '+=0.1'
      );

      tl.fromTo(
        '.about-us__cards-wrapper',
        { opacity: 0, scale: 0, top: '-540px' },
        { opacity: 1, scale: 1, top: '0', duration: 2, ease: 'power2.out' },
        'cardsStart'
      );

      tl.to('.about-us__body-dash', { opacity: 1, duration: 2 }, 'cardsStart');
      tl.to('.about-us__dash', { maxWidth: 415, duration: 0.75 }, '-=0.2');

      if (dash) {
        gsap.to(dash, {
          scrollTrigger: {
            trigger: wrapper,
            start: () => `top ${window.innerHeight * 0.222 - 170}px`,
            end: '+=2295',
            scrub: true,
          },
          height: 2475,
          ease: 'none',
        });
      }

      ScrollTrigger.refresh();
    }, wrapper);
  };

  initAboutUsAnimation();

  window.addEventListener('resize', () => {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(() => {
      ScrollTrigger.refresh();
      initAboutUsAnimation();
    }, 300);
  });
});
